// extracted by mini-css-extract-plugin
module.exports = {"modal":"pay_modal_modal__1_7eY","closeModal":"pay_modal_closeModal__D1hcz","container":"pay_modal_container__3wb4s"};